import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";
import {ExplainerPageModel} from "@/modules/muiutils/models/explainers/ExplainerPageModel";
import {ExplainerAddonModel} from "@/modules/muiutils/models/explainers/ExplainerAddonModel";

export class ExplainerModel extends BaseObject {

    constructor(pages) {
        super();
        this._key = null;
        this._custom_title = null;
        this._addon = new ExplainerAddonModel();
        this._pages = pages;
    }

    get key() {
        return this._key;
    }
    set key(value) {
        this._key = value;
    }

    get custom_title() {
        return this._custom_title;
    }
    set custom_title(value) {
        this._custom_title = value;
    }

    get addon() {
        return this._addon;
    }
    set addon(value) {
        this._addon = value;
    }

    get pages() {
        return this._pages;
    }
    set pages(value) {
        this._pages = value;
    }

    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ExplainerModel());
        } else if (target instanceof ExplainerModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }

    static schema() {
        return custom((v) => {
            return v && !v.empty() ? serialize(ExplainerModel, v) : SKIP;
        }, (v) => {
            return deserialize(ExplainerModel, v);
        });
    }
}

createModelSchema(ExplainerModel, {
    _key: alias("key", Schema.primitive()),
    _custom_title: alias("custom_title", Schema.primitive()),
    _addon: alias("addon", ExplainerAddonModel.schema()),
    _pages: alias("pages", list(ExplainerPageModel.schema())),
});